/* fg-employee-selection.js */
(function(){'use strict';

const IMAP={
  "Moore Vest|GREY MELANGE":"Q11240_GRME_A.jpg","Moore Vest|HOSTA":"Q11240_HSTA_A.jpg","Moore Vest|MARINE":"Q11240_MARI_A.jpg",
  "Commodore Windsweater|GRAPHITE HEATHER":"Q11241_GPHH.jpg","Commodore Windsweater|HOSTA HEATHER":"Q11241_HSTH.jpg","Commodore Windsweater|MARINE HEATHER":"Q11241_MRHE.jpg",
  "Montgomery Stripe Polo|BALTIC":"Q11500_BALT_A.jpg","Montgomery Stripe Polo|BLUFF":"Q11500_BLFF_A.jpg","Montgomery Stripe Polo|HOSTA":"Q11500_HSTA_A.jpg","Montgomery Stripe Polo|WHITE":"Q11500_WHIT_A.jpg","Montgomery Stripe Polo|MARINE":"Q11501_MARI_A.jpg",
  "Galiano Stripe Polo|BALTIC":"Q11501_BALT_A.jpg","Galiano Stripe Polo|MARINE":"Q11501_MARI_A.jpg","Galiano Stripe Polo|ICY PLUM":"Q11501_ICPL_A.jpg",
  "Gentry Stripe Polo|CARIBE":"Q11502_CRBE_A.jpg","Gentry Stripe Polo|WHITE":"Q11502_WHIT_A.jpg",
  "Vizcaya Print Polo|BALTIC":"Q11503_BALT_A.jpg","Vizcaya Print Polo|CALYPSO":"Q11503_CALY_A.jpg","Vizcaya Print Polo|PINEAPPLE":"Q11503_PNAP_A.jpg",
  "Lantana Print Polo|BALTIC":"Q11504_BALT_A.jpg","Lantana Print Polo|WHITE":"Q11504_WHIT_A.jpg","Lantana Print Polo|SUGAR APPLE":"Q11504_SGAP_A.jpg","Lantana Print Polo|MARINE":"Q11504_MARI_A.jpg",
  "Ibis Print Polo|CARIBE":"Q11505_CRBE_A.jpg","Ibis Print Polo|BLUFF":"Q11505_BLFF_A.jpg","Ibis Print Polo|PINEAPPLE":"Q11505_PNAP_A.jpg",
  "Bayshore Print Polo|BLUFF":"Q11506_BLFF_A.jpg","Bayshore Print Polo|BALTIC":"Q11506_BALT_A.jpg","Bayshore Print Polo|ICY PLUM":"Q11506_ICPL_A.jpg",
  "Mangrove Print Polo|BALTIC":"Q11508_BALT_A.jpg","Mangrove Print Polo|CALYPSO":"Q11508_CALY_A.jpg","Mangrove Print Polo|HOSTA":"Q11508_HSTA_A.jpg",
  "Morgan Long-Sleeve Polo|MARINE":"Q11509_MARI_A.jpg","Morgan Long-Sleeve Polo|MARINE VIZCAYA":"Q11509_MRVZ_A.jpg","Morgan Long-Sleeve Polo|RACING GREEN":"Q11509_RCGR_A.jpg","Morgan Long-Sleeve Polo|WHITE":"Q11509_WHIT_A.jpg",
  "USA National Print Polo|BALTIC":"Q11520_BALT_A.jpg","USA National Print Polo|CARDINAL":"Q11520_CARD_A.jpg","USA National Print Polo|WHITE":"Q11520_WHIT_A.jpg",
  "Caves Quarter Zip Hoodie|MARINE":"Q11530_MARI_A.jpg","Caves Quarter Zip Hoodie|BALTIC":"Q11530_BALT_A.jpg","Caves Quarter Zip Hoodie|RACING GREEN":"Q11530_RCGR_A.jpg","Caves Quarter Zip Hoodie|SUGAR APPLE":"Q11530_SGAP_A.jpg","Caves Quarter Zip Hoodie|WHITE":"Q11530_WHIT_A.jpg",
  "Caves Quarter Zip Pullover|BALTIC":"C11512_BALT_A.jpg","Caves Quarter Zip Pullover|SUGAR APPLE":"C11512_BKDS_A.jpg","Caves Quarter Zip Pullover|ICY PLUM":"C11512_BKDS_A.jpg","Caves Quarter Zip Pullover|CALYPSO":"C11512_BKDS_A.jpg","Caves Quarter Zip Pullover|HOSTA":"C11512_BKDS_A.jpg","Caves Quarter Zip Pullover|PINEAPPLE":"C11512_BKDS_A.jpg",
  "Caves Solid Quarter Zip Vest|SUGAR APPLE":"C11513_SGAP_A.jpg","Caves Solid Quarter Zip Vest|MARINE":"C11513_MARI_A.jpg","Caves Solid Quarter Zip Vest|BALTIC":"C11513_BALT_A.jpg","Caves Solid Quarter Zip Vest|WHITE":"C11513_WHIT_A.jpg",
  "Harold Full Zip Jacket|RACING GREEN":"Q31541_BALT_A_356460a5-fb53-49a9-ac59-151864b1e86d.jpg","Harold Full Zip Jacket|BALTIC":"Q31541_BALT_A_356460a5-fb53-49a9-ac59-151864b1e86d.jpg",
  "Park Stripe Polo|MARINE":"P11512_MARI.jpg","Park Stripe Polo|CALYPSO":"P11512_CALY_A.jpg","Park Stripe Polo|BALTIC/CALYPSO":"P11512_BLCL.jpg",
  "Middleton Solid Polo|CALYPSO":"P11510_CALY_A.jpg","Middleton Solid Polo|SUGAR APPLE":"P11510_SGAP_A.jpg","Middleton Solid Polo|MARINE":"P11510_MARI_8f206536-9332-44c3-977a-d79cc92c1dbb.jpg","Middleton Solid Polo|BALTIC":"P11510_BALT.jpg",
  "Fallon Quilted Vest|PALM":"Q12120_PALM_A.jpg","Fallon Quilted Vest|TIDEPOOL":"Q12120_TDPL_A.jpg",
  "Frannie Sleeveless|PIXIE":"Q12220_PIXI_A.jpg","Frannie Sleeveless|BLUESTONE":"Q12220_BSTN_A.jpg",
  "Fiona Sleeveless|PALM":"Q12221_PALM_A.jpg","Fiona Sleeveless|TIDEPOOL":"Q12221_TDPL_A.jpg",
  "Flora Sleeveless|WHITE":"Q12222_WHIT_A.jpg","Farrah Sleeveless|SAND":"Q12223_SAND_A.jpg",
  "Faye Polo|PIXIE":"Q12224_PIXI_A.jpg","Faith Polo|PALM":"Q12225_PALM_A.jpg","Faith Polo|WHITE":"Q12225_WHIT_A.jpg",
  "Finola Zip Mock|DEEP SEA":"Q12226_DPSE_A.jpg","Finley Zip Mock|PALM":"Q12227_PALM_A.jpg","Finley Zip Mock|DEEP SEA":"Q12227_DPSE_A.jpg",
  "Felicity Mock|PIXIE":"Q12228_PIXI_A.jpg","Felicity Mock|SAND":"Q12228_SAND_A.jpg",
  "Flannery Windsweater|BLUESTONE":"Q12270_BSTN_A.jpg","Flannery Windsweater|ECLIPSE":"Q12270_ECLI_A.jpg","Flannery Windsweater|PEARL":"Q12270_PERL_A.jpg","Flannery Windsweater|WILDBERRY":"Q12270_WLDB_A.jpg",
  "Fitz V-Neck Argyle Sweater|DEEP SEA":"Q12272_DPSE_A.jpg",
  "Fleur Skort|PIXIE":"Q12280_PIXI_A.jpg","Felicia Skort|PALM":"Q12281_PALM_A.jpg","Felicia Skort|BLUESTONE":"Q12281_BSTN_A.jpg","Foster Skort|SAND":"Q12282_SAND_A.jpg",
  "Carrie Skort|DEEP SEA":"K12184_PRDS_A.jpg","Carrie Skort|PIXIE":"K12184_PRDS_A.jpg",
  "Wells Quarter Zip|DEEP SEA":"F12250_BOCC_1.jpg","Wells Quarter Zip|WHITE/PIXIE":"F12250_BOCC_1.jpg",
  "Diana Sleeveless Pique Polo|PIXIE":"P12230_WHCR_A.jpg","Diana Sleeveless Pique Polo|DEEP SEA":"P12230_WHCR_A.jpg",
  "Cat Long Sleeve Zip|PIXIE":"N32228_BLOS_A.jpg"
};
const CDN='https://cdn.shopify.com/s/files/1/0012/9954/6178/files/';
function cdnUrl(name,color){const f=IMAP[name+'|'+color];return f?CDN+f:'';}

function buildImgMap(card){
  const name=card.dataset.name;
  const colors=card.dataset.colors.split(',').map(c=>c.trim()).filter(Boolean);
  let map={};try{map=JSON.parse(card.dataset.imgs||'{}');}catch(e){}
  colors.forEach(c=>{if(!map[c]){const u=cdnUrl(name,c);if(u)map[c]=u;}});
  return map;
}

const CS={};let SEL=[],gFilter='all',maxSel=2,webhookUrl='';

function init(){
  const cfg=window.fgEmpConfig||{},sid=Object.keys(cfg)[0];
  if(sid){maxSel=cfg[sid].maxSelections||2;webhookUrl=cfg[sid].webhookUrl||'';}
  document.querySelectorAll('.fg-emp__card').forEach(card=>{
    const bid=card.dataset.block;
    const colors=card.dataset.colors.split(',').map(c=>c.trim()).filter(Boolean);
    const imgMap=buildImgMap(card);
    CS[bid]={color:colors[0]||'',size:'',imgMap};
    const cdnImg=card.querySelector('.fg-emp__card-img--cdn');
    if(cdnImg&&colors[0]){
      const u=imgMap[colors[0]];
      if(u){cdnImg.src=u;cdnImg.style.display='';const ph=card.querySelector('.fg-emp__card-ph');if(ph)ph.style.display='none';}
    }
  });
  document.addEventListener('click',handleClick);
  updateBar();
  setTimeout(()=>{const s=document.getElementById('fg-sticky');if(s)s.classList.add('fg-emp__sticky-cta--visible');},300);
}

function handleClick(e){
  const csw=e.target.closest('.fg-emp__cswb');if(csw){onColor(csw);return;}
  const szb=e.target.closest('.fg-emp__szb');if(szb){onSize(szb);return;}
  const add=e.target.closest('.fg-emp__card-add');if(add){onAdd(add);return;}
  const rem=e.target.closest('[data-remove]');if(rem){removeBid(rem.dataset.remove);return;}
  const gtgl=e.target.closest('.fg-emp__gtgl');if(gtgl){onGender(gtgl);return;}
  if(e.target.id==='fg-emp-browse'){document.getElementById('fg-emp-s1')?.scrollIntoView({behavior:'smooth'});return;}
  if(e.target.id==='fg-nxt1'||e.target.id==='fg-sticky-btn'){toStep2();return;}
  if(e.target.id==='fg-back2'){toStep1();return;}
  if(e.target.id==='fg-subbtn'){doSubmit();return;}
}

function onColor(csw){
  const card=csw.closest('.fg-emp__card'),bid=card.dataset.block,color=csw.dataset.color;
  CS[bid].color=color;
  const u=CS[bid].imgMap[color];
  const img=card.querySelector('.fg-emp__card-img'),ph=card.querySelector('.fg-emp__card-ph');
  if(img){if(u){img.src=u;img.alt=card.dataset.name+' in '+color;img.style.display='';if(ph)ph.style.display='none';}else{img.style.display='none';if(ph)ph.style.display='';}}
  const lbl=card.querySelector('.fg-emp__clabel');if(lbl)lbl.textContent=color;
  card.querySelectorAll('.fg-emp__cswb').forEach(b=>b.classList.toggle('fg-emp__cswb--on',b.dataset.color===color));
  const idx=SEL.findIndex(s=>s.blockId===bid);if(idx>-1){SEL[idx].color=color;updateBar();}
}

function onSize(szb){
  const card=szb.closest('.fg-emp__card'),bid=card.dataset.block,sz=szb.dataset.sz;
  CS[bid].size=sz;
  card.querySelectorAll('.fg-emp__szb').forEach(b=>b.classList.toggle('fg-emp__szb--on',b.dataset.sz===sz));
  card.querySelector('.fg-emp__szerr')?.classList.remove('fg-emp__szerr--show');
}

function onAdd(btn){
  const card=btn.closest('.fg-emp__card'),bid=card.dataset.block;
  if(btn.classList.contains('fg-emp__card-add--rem')){SEL=SEL.filter(s=>s.blockId!==bid);updateBar();renderStates();return;}
  const st=CS[bid]||{};
  if(!st.size){card.querySelector('.fg-emp__szerr')?.classList.add('fg-emp__szerr--show');return;}
  if(SEL.length>=maxSel)return;
  SEL.push({blockId:bid,name:card.dataset.name,color:st.color,size:st.size,type:card.dataset.type,price:card.dataset.price});
  updateBar();renderStates();
}

function removeBid(bid){SEL=SEL.filter(s=>s.blockId!==bid);updateBar();renderStates();}

function renderStates(){
  document.querySelectorAll('.fg-emp__card').forEach(card=>{
    const bid=card.dataset.block,isSel=SEL.some(s=>s.blockId===bid),isDis=!isSel&&SEL.length>=maxSel;
    card.classList.toggle('fg-emp__card--sel',isSel);card.classList.toggle('fg-emp__card--dis',isDis);
    const btn=card.querySelector('.fg-emp__card-add');
    if(btn){btn.textContent=isSel?'Remove':'Add to selection';btn.classList.toggle('fg-emp__card-add--rem',isSel);}
  });
}

function onGender(gtgl){
  gFilter=gtgl.dataset.g;
  document.querySelectorAll('.fg-emp__gtgl').forEach(b=>b.classList.toggle('fg-emp__gtgl--on',b.dataset.g===gFilter));
  document.querySelectorAll('.fg-emp__gender-section').forEach(sec=>sec.style.display=(gFilter==='all'||gFilter===sec.dataset.gender)?'':'none');
}

function updateBar(){
  const n=SEL.length;
  const cnt=document.getElementById('fg-cnt');if(cnt)cnt.textContent=n;
  const slbl=document.getElementById('fg-sticky-label');if(slbl)slbl.innerHTML='<strong>'+n+'</strong> of '+maxSel+' selected';
  const chips=document.getElementById('fg-chips');
  if(chips){chips.replaceChildren();SEL.forEach(s=>{const sp=document.createElement('span');sp.className='fg-emp__sel-chip';sp.innerHTML=esc(s.name)+' · '+esc(s.color)+'<button data-remove="'+s.blockId+'" aria-label="Remove">×</button>';chips.appendChild(sp);});}
  ['fg-nxt1','fg-sticky-btn'].forEach(id=>{const b=document.getElementById(id);if(b)b.disabled=n<maxSel;});
}

function setProg(step){[1,2,3].forEach(i=>{const el=document.getElementById('fg-prog-'+i);if(!el)return;el.classList.toggle('active',i===step);el.classList.toggle('done',i<step);});}

function showStep(id){
  document.querySelectorAll('.fg-emp__step').forEach(s=>s.classList.remove('fg-emp__step--visible'));
  document.getElementById(id)?.classList.add('fg-emp__step--visible');
  const sticky=document.getElementById('fg-sticky');if(sticky)sticky.classList.toggle('fg-emp__sticky-cta--visible',id==='fg-emp-s1');
  const prog=document.getElementById('fg-emp-progress');
  requestAnimationFrame(()=>{const top=prog?prog.getBoundingClientRect().top+window.scrollY-4:0;window.scrollTo({top,behavior:'smooth'});});
}

function fieldVal(id){const el=document.getElementById(id);return el?el.value.trim():'';}

function toStep2(){
  showStep('fg-emp-s2');setProg(2);
  const rv=document.getElementById('fg-review');
  if(rv)rv.innerHTML=SEL.map((s,i)=>'<div class="fg-emp__rv-card"><div class="fg-emp__rv-eye">Item '+(i+1)+' of '+maxSel+'</div><div class="fg-emp__rv-name">'+esc(s.name)+'</div><div class="fg-emp__rv-row"><span>Color</span><span>'+esc(s.color)+'</span></div><div class="fg-emp__rv-row"><span>Size</span><span>'+esc(s.size)+'</span></div><div class="fg-emp__rv-row"><span>Type</span><span>'+esc(s.type)+'</span></div></div>').join('');
}

function toStep1(){showStep('fg-emp-s1');setProg(1);}

async function doSubmit(){
  const fn=fieldVal('fg-fn'),ln=fieldVal('fg-ln'),em=fieldVal('fg-em'),
        dept=fieldVal('fg-dept'),office=fieldVal('fg-office'),
        a1=fieldVal('fg-a1'),a2=fieldVal('fg-a2'),
        city=fieldVal('fg-city'),state=fieldVal('fg-state'),
        zip=fieldVal('fg-zip'),phone=fieldVal('fg-phone');

  const errEl=document.getElementById('fg-err');
  const missing=[];
  if(!fn)missing.push('First name');
  if(!ln)missing.push('Last name');
  if(!em)missing.push('Work email');
  if(!dept)missing.push('Department');
  if(!a1)missing.push('Street address');
  if(!city)missing.push('City');
  if(!state)missing.push('State');
  if(!zip)missing.push('ZIP code');

  if(missing.length){
    if(errEl){errEl.textContent='Please complete: '+missing.join(', ')+'.';errEl.style.display='block';}
    return;
  }
  if(errEl)errEl.style.display='none';

  const btn=document.getElementById('fg-subbtn');
  if(btn){btn.disabled=true;btn.innerHTML='<span class="fg-emp__spin"></span>Submitting…';}

  const cfg=window.fgEmpConfig||{},sid=Object.keys(cfg)[0];
  const hook=webhookUrl||(cfg[sid]?.webhookUrl||'');

  const rows=SEL.map((s,i)=>({
    timestamp:new Date().toISOString(),
    firstName:fn,lastName:ln,email:em,
    department:dept,officeLocation:office||'New York',
    address:a1+(a2?', '+a2:''),city,state,zip,phone,
    item:i+1,product:s.name,color:s.color,type:s.type,size:s.size,price:'$'+s.price
  }));

  try{
    if(!hook)throw new Error('no_webhook');
    const res=await fetch(hook,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(rows)});
    const data=await res.json();
    if(data.success===false)throw new Error(data.error||'Server error');

    showStep('fg-emp-s3');setProg(3);
    const summ=document.getElementById('fg-conf-summ');
    if(summ)summ.innerHTML=
      '<div class="fg-emp__conf-row"><span>Name</span><span>'+esc(fn)+' '+esc(ln)+'</span></div>'+
      '<div class="fg-emp__conf-row"><span>Email</span><span>'+esc(em)+'</span></div>'+
      '<div class="fg-emp__conf-row"><span>Department</span><span>'+esc(dept)+'</span></div>'+
      '<div class="fg-emp__conf-row"><span>Office</span><span>'+esc(office||'New York')+'</span></div>'+
      '<div class="fg-emp__conf-row"><span>Ship to</span><span>'+esc(a1+(a2?', '+a2:''))+', '+esc(city)+', '+esc(state)+' '+esc(zip)+'</span></div>'+
      SEL.map((s,i)=>'<div class="fg-emp__conf-row"><span>Item '+(i+1)+'</span><span>'+esc(s.name)+' · '+esc(s.color)+' · '+esc(s.size)+'</span></div>').join('');

  }catch(err){
    if(btn){btn.disabled=false;btn.innerHTML='Submit my selections';}
    if(errEl){
      errEl.textContent=err.message==='no_webhook'
        ?'Form not connected yet — webhook URL needed in theme editor settings.'
        :'Submission failed — please try again or contact Fardan directly.';
      errEl.style.display='block';
    }
  }
}

function esc(str){return String(str).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}else{init();}
})();
